import { render, staticRenderFns } from "./GuideTravelDetail.vue?vue&type=template&id=5cd9b48c&scoped=true&"
import script from "./GuideTravelDetail.vue?vue&type=script&lang=js&"
export * from "./GuideTravelDetail.vue?vue&type=script&lang=js&"
import style0 from "./GuideTravelDetail.vue?vue&type=style&index=0&id=5cd9b48c&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd9b48c",
  null
  
)

export default component.exports